module.exports = __webpack_public_path__ + "img/EMT-BRCA_10X_WTA.f44bee82.png";